module.exports = __webpack_public_path__ + "img/mico-thumb.d986c218.jpg";